import React from 'react'

import {
  PresenterStyled,
  PresenterMediaStyled,
  PresenterMediaBgStyled,
  PresenterMediaImageStyled,
  PresenterContentStyled,
  PresenterContentNameStyled,
  PresenterContentDescStyled,
  PresenterBackgroundImageStyled
} from './styles'
import { PresenterProps } from './types'
import MediaItem from './../../molecules/MediaItem'

const Presenter: React.FC<PresenterProps> = ({ data: { photo, backgroundImage, name, description } }) => {
  return (
    <PresenterStyled>
      <PresenterMediaStyled>
        <PresenterMediaBgStyled>
          <PresenterMediaImageStyled>{photo && <MediaItem media={photo} objectFit="cover" />}</PresenterMediaImageStyled>
        </PresenterMediaBgStyled>
      </PresenterMediaStyled>
      <PresenterContentStyled>
        <PresenterContentNameStyled variant="headingRaleway9">{name}</PresenterContentNameStyled>
        <PresenterContentDescStyled dangerouslySetInnerHTML={{ __html: description }} />
      </PresenterContentStyled>
      {backgroundImage && (
        <PresenterBackgroundImageStyled>
          <MediaItem media={backgroundImage} objectFit="cover" />
        </PresenterBackgroundImageStyled>
      )}
    </PresenterStyled>
  )
}

export default Presenter
